import certificates from '../../Actions/notification';
const { types } = certificates;

const initialState = {
    notificationsPagination:{
        page: 1,
        pageCount: 1,
        perPage: 5,
        totalCount:5
    },
    notifications:[],
    isNotificationsLoading: false
};


const notificationReducer = (state = initialState, action) => {

    switch (action.type) {
        case types.GET_NOTIFICATIONS:
            return {
                ...state,
                isNotificationsLoading: true
            }
        case types.SET_NOTIFICATIONS:            
            return {
                ...state,
                notifications: action.data.records,
                notificationsPagination: action.data.metaData,
                isNotificationsLoading: false
            }
        default:
            return state;
    }
}

export default notificationReducer;